import React from 'react';
import type { IconProps } from '../types';

export const ContentNext = (props: IconProps) => (
  <svg
    width="6px"
    height="10px"
    viewBox="0 0 6 10"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="Icons"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Artboard"
        transform="translate(-460, -343)"
        fill="#FFFFFF"
      >
        <polygon
          id="chevron-next"
          transform="translate(463, 348) scale(-1, 1) rotate(90) translate(-463, -348)"
          points="463 351 458 345.736842 458.7 345 463 349.526316 467.3 345 468 345.736842"
        ></polygon>
      </g>
    </g>
  </svg>
);

export default ContentNext;
